// Roofing Templates
// T6: "Ridgeline" — Premium residential contractor, cream/white + terracotta, Fjalla One + Source Sans 3
// T7: "Stormguard" — Aggressive storm specialist, near-black + electric yellow, Barlow Condensed

export const ROOFING_DEFAULT_COPY = {
  T6: {
    eyebrow: "Northeast Ohio's Trusted Roofers Since 1987",
    headline: "Built to Last. Backed by Experience.",
    tagline: "From minor repairs to full replacements, we protect what matters most. Licensed, insured, and backed by 35 years of craftsmanship.",
    about: "For over three decades, we've been the name Northeast Ohio homeowners trust when their roof needs work. Our certified roofers bring old-school craftsmanship and modern materials to every job, residential or commercial, repair or full replacement. We stand behind every shingle we nail.",
  },
  T7: {
    eyebrow: "Storm Damage Response — 24/7 Emergency Service",
    headline: "Your Roof Took a Hit. We'll Make It Right.",
    tagline: "Fast response. Insurance claim specialists. No-hassle roof replacement.",
    about: "When a storm rolls through Northeast Ohio, we're the first call homeowners make — and the last company they ever need to hire. We handle everything from emergency tarping to full replacement, and we work directly with your insurance company so you don't have to fight for what you're owed.",
  },
};

export const ROOFING_DEFAULT_SERVICES = {
  6: [
    { icon: "fa-house",             title: "Full Roof Replacement", desc: "Architectural shingles, metal, slate, and flat roofing systems installed to last 30 to 50 years with manufacturer-backed warranties." },
    { icon: "fa-droplet",           title: "Leak Repairs",          desc: "We track down every leak and fix it right the first time. No guesswork, no callbacks, just a dry home and a clear explanation of what we found." },
    { icon: "fa-cloud-bolt",        title: "Storm Damage Repair",   desc: "Emergency tarping, hail damage, wind-blown shingles. Fast turnaround, insurance-ready documentation, and no upfront cost for claims." },
    { icon: "fa-building",          title: "Commercial Roofing",    desc: "TPO, EPDM, and modified bitumen systems for flat and low-slope commercial buildings. Multi-unit and industrial projects welcome." },
    { icon: "fa-water",             title: "Gutters & Fascia",      desc: "Seamless aluminum gutters, fascia board replacement, and complete drainage solutions that protect your foundation and landscaping." },
    { icon: "fa-magnifying-glass",  title: "Free Inspections",      desc: "No-pressure roof assessments with detailed photo reports and honest recommendations, before or after any storm." },
  ],
  7: [
    { icon: "fa-triangle-exclamation", title: "Emergency Tarping",      desc: "We're on-site within hours of a storm to secure your home against further damage." },
    { icon: "fa-file-invoice-dollar",  title: "Insurance Claims",       desc: "We document all damage, meet with adjusters, and maximize your claim payout." },
    { icon: "fa-house",                title: "Full Replacement",        desc: "Hail, wind, age — whatever took out your old roof, we put on a better one." },
    { icon: "fa-screwdriver-wrench",   title: "Repairs & Patches",      desc: "Not every storm calls for a full job. We repair what needs repairing, nothing more." },
    { icon: "fa-layer-group",          title: "Flat & Low-Slope",        desc: "Commercial and residential flat roofing systems with full waterproofing guarantees." },
    { icon: "fa-clipboard-check",      title: "Free Damage Assessment",  desc: "On-site storm inspection with photos, scope of work, and insurance paperwork support." },
  ],
};

export function buildRoofingServiceCardsT6(services) {
  return services.map((s, i) => `
    <a href="#contact" class="srv-card anim d${(i % 3) + 1}">
      <div class="srv-icon"><i class="fa-solid ${s.icon}" aria-hidden="true"></i></div>
      <h3>${s.title}</h3>
      <p>${s.desc}</p>
      <span class="srv-card-link">Get a Quote <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
    </a>`).join('');
}

export function buildRoofingServiceCardsT7(services) {
  return services.map((s, i) => `
    <div class="srv-card anim d${i + 1}">
      <div class="card-num">${String(i + 1).padStart(2, '0')}</div>
      <div class="card-icon"><i class="fa-solid ${s.icon}"></i></div>
      <h3>${s.title}</h3>
      <p>${s.desc}</p>
    </div>`).join('');
}

// ─── T6: "Ridgeline" ─────────────────────────────────────────────────────────
const T6 = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>PLACEHOLDER_COMPANY | Roofing Contractors</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Fjalla+One&family=Source+Sans+3:wght@300;400;500;600;700&display=swap" rel="stylesheet">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css">
<style>
PLACEHOLDER_BRAND_COLORS_T6
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth}
body{font-family:'Source Sans 3',sans-serif;background:var(--bg);color:var(--text);overflow-x:hidden}
img{display:block;max-width:100%}
#services,#about,#why,#contact{scroll-margin-top:72px}
h1,h2,h3{text-wrap:balance}
a:focus-visible,button:focus-visible,input:focus-visible,select:focus-visible,textarea:focus-visible{
  outline:3px solid var(--terra);outline-offset:3px
}

/* ACCESSIBILITY */
.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}
.skip-link{
  position:absolute;top:-100%;left:12px;z-index:9999;
  background:var(--terra);color:#fff;font-family:'Fjalla One',sans-serif;
  font-size:14px;letter-spacing:0.08em;text-transform:uppercase;
  padding:10px 22px;text-decoration:none;transition:top 0.2s
}
.skip-link:focus{top:12px}

/* SCROLL ANIMATIONS */
.anim{opacity:0;transform:translateY(36px);transition:opacity 0.7s cubic-bezier(0.22,1,0.36,1),transform 0.7s cubic-bezier(0.22,1,0.36,1)}
.anim.left{transform:translateX(-44px)}
.anim.right{transform:translateX(44px)}
.anim.on{opacity:1!important;transform:none!important}
.d1{transition-delay:.08s}.d2{transition-delay:.16s}.d3{transition-delay:.24s}
.d4{transition-delay:.32s}.d5{transition-delay:.40s}.d6{transition-delay:.48s}
@media(prefers-reduced-motion:reduce){
  .anim{opacity:1;transform:none;transition:none}
  .anim.left,.anim.right{transform:none}
}

/* NAV */
nav{
  position:fixed;top:0;left:0;right:0;z-index:300;
  height:72px;background:var(--slate);
  display:grid;grid-template-columns:1fr auto 1fr;
  align-items:center;padding:0 40px;
}
.nav-left{display:flex;align-items:center;gap:32px}
.nav-links{display:flex;gap:28px;list-style:none}
.nav-links a{
  font-family:'Source Sans 3',sans-serif;font-size:12px;font-weight:600;
  letter-spacing:0.12em;text-transform:uppercase;
  color:rgba(255,255,255,0.5);text-decoration:none;transition:color 0.2s
}
.nav-links a:hover{color:#fff}
.nav-logo{
  font-family:'Fjalla One',sans-serif;font-size:22px;
  color:#fff;letter-spacing:0.04em;text-transform:uppercase;
  text-decoration:none;white-space:nowrap;text-align:center;
  display:flex;align-items:center;gap:10px
}
.nav-logo span{color:var(--terra)}
.nav-logo-img{height:34px;width:auto;object-fit:contain;filter:brightness(0) invert(1)}
.nav-right{display:flex;align-items:center;gap:16px;justify-content:flex-end}
.nav-phone{
  font-family:'Source Sans 3',sans-serif;font-size:15px;font-weight:700;
  color:#fff;text-decoration:none;display:flex;align-items:center;gap:8px;
  transition:color 0.2s
}
.nav-phone i{color:var(--terra);font-size:13px}
.nav-phone:hover{color:var(--terra)}
.nav-cta{
  background:var(--terra);color:#fff;
  font-family:'Fjalla One',sans-serif;font-size:13px;
  letter-spacing:0.1em;text-transform:uppercase;
  padding:9px 22px;text-decoration:none;
  transition:background 0.2s
}
.nav-cta:hover{background:var(--terra-dk)}

/* HERO */
.hero{
  margin-top:72px;
  position:relative;
  min-height:560px;
  display:flex;align-items:center;
  overflow:hidden;
}
.hero-bg{
  position:absolute;inset:0;
  background:center/cover no-repeat;
  z-index:0;
}
.hero-overlay{
  position:absolute;inset:0;z-index:1;
  background:linear-gradient(
    105deg,
    rgba(249,247,244,0.97) 0%,
    rgba(249,247,244,0.88) 38%,
    rgba(28,35,49,0.72) 62%,
    rgba(28,35,49,0.85) 100%
  )
}
.hero-inner{
  position:relative;z-index:2;
  width:100%;max-width:1200px;
  margin:0 auto;padding:64px 48px;
  display:grid;grid-template-columns:1fr 420px;gap:60px;align-items:center;
}
.hero-eyebrow{
  font-family:'Source Sans 3',sans-serif;font-size:11px;font-weight:700;
  letter-spacing:0.22em;text-transform:uppercase;color:var(--terra);
  margin-bottom:18px;display:flex;align-items:center;gap:10px
}
.hero-eyebrow::before{content:'';width:24px;height:2px;background:var(--terra);flex-shrink:0}
.hero-h1{
  font-family:'Fjalla One',sans-serif;
  font-size:clamp(46px,5.8vw,76px);
  line-height:1.0;letter-spacing:0.01em;
  color:var(--slate);margin-bottom:18px;
}
.hero-h1 em{color:var(--terra);font-style:normal}
.hero-sub{
  font-size:17px;line-height:1.7;color:var(--muted);
  font-weight:400;max-width:420px;margin-bottom:32px
}
.hero-bullets{
  list-style:none;display:flex;flex-direction:column;gap:9px;margin-bottom:36px
}
.hero-bullets li{
  display:flex;align-items:center;gap:10px;
  font-size:14px;font-weight:600;color:var(--text)
}
.hero-bullets i{color:var(--terra);font-size:13px;flex-shrink:0}
.hero-cta-row{display:flex;align-items:center;gap:20px;flex-wrap:wrap}
.hero-btn{
  background:var(--terra);color:#fff;
  font-family:'Fjalla One',sans-serif;font-size:15px;
  letter-spacing:0.1em;text-transform:uppercase;
  padding:16px 36px;text-decoration:none;
  display:inline-flex;align-items:center;gap:10px;
  transition:background 0.2s,transform 0.15s
}
.hero-btn:hover{background:var(--terra-dk);transform:translateY(-2px)}
.hero-phone-link{
  font-family:'Fjalla One',sans-serif;font-size:18px;
  color:var(--slate);text-decoration:none;
  display:flex;align-items:center;gap:8px;
  transition:color 0.2s
}
.hero-phone-link i{color:var(--terra)}
.hero-phone-link:hover{color:var(--terra)}

/* Form card */
.hero-form-card{
  background:var(--white);
  border-top:4px solid var(--terra);
  padding:36px 32px;
  box-shadow:0 32px 80px rgba(0,0,0,0.18),0 4px 20px rgba(0,0,0,0.1)
}
.hfc-title{
  font-family:'Fjalla One',sans-serif;font-size:20px;
  letter-spacing:0.04em;text-transform:uppercase;
  color:var(--slate);margin-bottom:4px
}
.hfc-sub{font-size:13px;color:var(--muted);font-weight:400;margin-bottom:24px}
.hf-group{display:flex;flex-direction:column;gap:5px;margin-bottom:12px}
.hf-group label{
  font-size:10px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;
  color:var(--muted)
}
.hf-input,.hf-select{
  width:100%;background:var(--bg);border:1px solid var(--border);
  padding:12px 14px;
  font-family:'Source Sans 3',sans-serif;font-size:14px;color:var(--text);
  outline:none;border-radius:0;
  transition:border-color 0.2s,background 0.2s
}
.hf-input::placeholder{color:#b8b2aa}
.hf-input:focus,.hf-select:focus{border-color:var(--terra);background:var(--white)}
.hf-select{cursor:pointer}
.hf-row{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.hf-submit{
  width:100%;background:var(--terra);color:#fff;border:none;
  font-family:'Fjalla One',sans-serif;font-size:15px;
  letter-spacing:0.1em;text-transform:uppercase;
  padding:15px;cursor:pointer;
  display:flex;align-items:center;justify-content:center;gap:10px;
  margin-top:6px;
  transition:background 0.2s,transform 0.15s
}
.hf-submit:hover{background:var(--terra-dk);transform:translateY(-1px)}
.hf-note{text-align:center;font-size:11px;color:var(--muted);margin-top:10px}
.hf-note i{color:#16a34a;margin-right:4px}

/* TRUST BAR */
.trust-bar{
  background:var(--cream);
  border-top:1px solid var(--border);
  border-bottom:1px solid var(--border);
  padding:0 48px;overflow:hidden;
}
.trust-bar-inner{
  display:flex;align-items:stretch;
  max-width:1200px;margin:0 auto;
}
.trust-item{
  flex:1;padding:22px 24px;
  display:flex;align-items:center;gap:14px;
  border-right:1px solid var(--border);
}
.trust-item:last-child{border-right:none}
.trust-icon{
  width:42px;height:42px;flex-shrink:0;
  background:var(--terra);
  display:flex;align-items:center;justify-content:center;
  color:#fff;font-size:16px;
}
.trust-item h4{
  font-family:'Fjalla One',sans-serif;font-size:13px;
  letter-spacing:0.06em;text-transform:uppercase;color:var(--text);
  margin-bottom:1px
}
.trust-item p{font-size:12px;color:var(--muted);font-weight:400;line-height:1.4}

/* SERVICES */
.services{
  background:var(--white);
  padding:100px 48px 148px;
  position:relative;
}
.services::after{
  content:'';position:absolute;bottom:0;left:0;right:0;height:72px;
  background:var(--cream);
  clip-path:polygon(0 100%, 100% 0, 100% 100%);
  pointer-events:none
}
.section-head{text-align:center;max-width:640px;margin:0 auto 64px}
.sec-label{
  display:inline-flex;align-items:center;gap:10px;
  font-size:11px;font-weight:700;letter-spacing:0.22em;text-transform:uppercase;
  color:var(--terra);margin-bottom:14px
}
.sec-label::before,.sec-label::after{content:'';width:22px;height:2px;background:var(--terra)}
.sec-h2{
  font-family:'Fjalla One',sans-serif;
  font-size:clamp(34px,4.2vw,54px);
  color:var(--text);line-height:1.05;letter-spacing:0.01em
}
.sec-h2 em{color:var(--terra);font-style:normal}
.sec-sub{font-size:16px;color:var(--muted);font-weight:400;line-height:1.7;margin-top:14px}

.services-grid{
  display:grid;grid-template-columns:repeat(3,1fr);
  gap:1px;background:var(--border);
  border:1px solid var(--border);
  max-width:1200px;margin:0 auto;
}
.srv-card{
  display:block;text-decoration:none;color:inherit;
  background:var(--white);padding:40px 32px;
  position:relative;overflow:hidden;
  transition:background 0.3s
}
.srv-card::after{
  content:'';position:absolute;bottom:0;left:0;
  width:0;height:3px;background:var(--terra);
  transition:width 0.45s cubic-bezier(0.22,1,0.36,1)
}
.srv-card:hover{background:var(--bg)}
.srv-card:hover::after{width:100%}
.srv-icon{
  width:52px;height:52px;
  background:var(--cream);border:1px solid var(--border);
  display:flex;align-items:center;justify-content:center;
  margin-bottom:18px;
  transition:background 0.3s,border-color 0.3s
}
.srv-icon i{font-size:20px;color:var(--terra);transition:color 0.3s,transform 0.3s}
.srv-card:hover .srv-icon{background:var(--terra);border-color:var(--terra)}
.srv-card:hover .srv-icon i{color:#fff;transform:scale(1.1)}
.srv-card h3{
  font-family:'Fjalla One',sans-serif;font-size:19px;
  letter-spacing:0.03em;text-transform:uppercase;
  color:var(--text);margin-bottom:10px
}
.srv-card p{font-size:14px;color:var(--muted);line-height:1.7;font-weight:400}
.srv-card-link{
  display:inline-flex;align-items:center;gap:7px;
  margin-top:14px;font-size:12px;font-weight:700;
  letter-spacing:0.1em;text-transform:uppercase;
  color:var(--terra);transition:gap 0.2s
}
.srv-card:hover .srv-card-link{gap:11px}

/* PHOTO WALL */
.photo-wall{
  display:grid;grid-template-columns:2fr 1.2fr 0.9fr;
  height:420px;gap:3px;background:var(--slate);
  overflow:hidden;
}
.pb-cell{overflow:hidden;position:relative}
.pb-cell img{
  width:100%;height:100%;object-fit:cover;
  filter:brightness(0.9) saturate(1.05)
}
.pb-overlay{
  position:absolute;inset:0;
  background:linear-gradient(to top,rgba(0,0,0,0.45) 0%,transparent 55%)
}

/* STATS STRIP */
.stats-strip{
  background:var(--terra);padding:56px 48px;
  display:flex;justify-content:center;
  position:relative;overflow:hidden
}
.stats-strip::before{
  content:'';position:absolute;inset:0;pointer-events:none;
  background-image:repeating-linear-gradient(
    -52deg,rgba(0,0,0,0.06) 0,rgba(0,0,0,0.06) 1px,
    transparent 1px,transparent 20px
  )
}
.stats-inner{
  position:relative;z-index:1;
  max-width:1000px;width:100%;
  display:flex;justify-content:space-between
}
.stat-box{
  flex:1;text-align:center;padding:0 32px;
  border-right:1px solid rgba(255,255,255,0.22)
}
.stat-box:last-child{border-right:none}
.stat-num{
  font-family:'Fjalla One',sans-serif;font-size:60px;
  color:#fff;line-height:1;display:block;letter-spacing:0.01em
}
.stat-lbl{
  font-size:11px;font-weight:700;letter-spacing:0.16em;text-transform:uppercase;
  color:rgba(255,255,255,0.78);margin-top:8px;display:block
}

/* ABOUT */
.about{
  background:var(--cream);padding:100px 48px 148px;
  position:relative
}
.about::after{
  content:'';position:absolute;bottom:0;left:0;right:0;height:72px;
  background:var(--white);
  clip-path:polygon(0 100%, 100% 0, 100% 100%);
  pointer-events:none
}
.about-inner{
  max-width:1200px;margin:0 auto;
  display:grid;grid-template-columns:1fr 1fr;gap:80px;align-items:center
}
.about-photos{
  display:grid;
  grid-template-columns:1.2fr 0.8fr;
  grid-template-rows:1fr 180px;
  gap:10px;height:520px
}
.aph-main{grid-row:1/3;overflow:hidden}
.aph-main img,.aph-sm img{width:100%;height:100%;object-fit:cover;display:block}
.aph-sm{overflow:hidden}
.aph-stat{
  background:var(--terra);
  display:flex;flex-direction:column;align-items:center;justify-content:center;
  text-align:center;padding:20px
}
.aph-stat strong{
  font-family:'Fjalla One',sans-serif;font-size:44px;
  color:#fff;line-height:1;display:block
}
.aph-stat span{
  font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;
  color:rgba(255,255,255,0.82);margin-top:6px;display:block
}

.about-content h2{
  font-family:'Fjalla One',sans-serif;
  font-size:clamp(32px,4vw,52px);
  color:var(--text);line-height:1.05;margin-bottom:18px
}
.about-content h2 em{color:var(--terra);font-style:normal}
.about-content>p{
  font-size:16px;color:var(--muted);line-height:1.8;
  font-weight:400;margin-bottom:28px
}
.about-checklist{list-style:none;display:flex;flex-direction:column;gap:12px;margin-bottom:28px}
.about-checklist li{
  display:flex;align-items:flex-start;gap:12px;
  font-size:15px;color:var(--text);font-weight:500
}
.about-checklist i{color:var(--terra);font-size:13px;flex-shrink:0;margin-top:3px}
.cert-row{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:32px}
.cert-tag{
  font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;
  background:var(--white);border:1px solid var(--border);
  border-left:3px solid var(--terra);
  color:var(--text);padding:7px 13px
}
.btn-terra{
  background:var(--terra);color:#fff;
  font-family:'Fjalla One',sans-serif;font-size:14px;
  letter-spacing:0.1em;text-transform:uppercase;
  padding:16px 32px;text-decoration:none;
  display:inline-flex;align-items:center;gap:10px;
  transition:background 0.2s,transform 0.15s
}
.btn-terra:hover{background:var(--terra-dk);transform:translateY(-2px)}

/* TESTIMONIALS */
.testimonials{
  background:var(--white);
  padding:100px 48px 148px;
  position:relative
}
.testimonials::after{
  content:'';position:absolute;bottom:0;left:0;right:0;height:72px;
  background:var(--slate);
  clip-path:polygon(0 0, 100% 100%, 0 100%);
  pointer-events:none
}
.testi-grid{
  display:grid;grid-template-columns:repeat(3,1fr);gap:24px;
  max-width:1200px;margin:0 auto
}
.testi-card{
  background:var(--bg);border:1px solid var(--border);
  border-top:4px solid var(--terra);
  padding:32px 28px
}
.testi-stars{display:flex;gap:3px;margin-bottom:14px}
.testi-stars i{color:#f59e0b;font-size:14px}
.testi-text{
  font-size:15px;color:var(--text);line-height:1.76;
  font-style:italic;font-weight:400;margin-bottom:22px
}
.testi-author{display:flex;align-items:center;gap:12px}
.testi-avatar{
  width:42px;height:42px;flex-shrink:0;
  background:var(--terra);border-radius:50%;
  display:flex;align-items:center;justify-content:center;
  font-family:'Fjalla One',sans-serif;font-size:14px;color:#fff
}
.testi-name{
  font-family:'Fjalla One',sans-serif;font-size:14px;
  text-transform:uppercase;letter-spacing:0.04em;color:var(--text);
  display:block
}
.testi-meta{font-size:12px;color:var(--muted);font-weight:400}

/* WHY RIDGELINE */
.why{
  background:var(--slate);padding:100px 48px;
  position:relative;overflow:hidden
}
.why::before{
  content:'';position:absolute;inset:0;pointer-events:none;
  background-image:repeating-linear-gradient(
    -52deg,rgba(255,255,255,0.018) 0,rgba(255,255,255,0.018) 1px,
    transparent 1px,transparent 14px
  )
}
.why-inner{
  position:relative;z-index:1;
  max-width:1200px;margin:0 auto
}
.why-intro{
  display:grid;grid-template-columns:1fr 1.6fr;gap:64px;align-items:start;
  margin-bottom:56px
}
.why-intro h2{
  font-family:'Fjalla One',sans-serif;
  font-size:clamp(36px,4.5vw,60px);
  color:#fff;line-height:1.02
}
.why-intro h2 em{color:var(--terra);font-style:normal;display:block}
.why-intro p{
  font-size:16px;color:rgba(255,255,255,0.5);
  line-height:1.8;font-weight:300;margin-top:8px
}
.why-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:20px}
.why-card{
  border:1px solid rgba(255,255,255,0.08);padding:32px 26px;
  position:relative;overflow:hidden;
  transition:border-color 0.3s,background 0.3s,transform 0.3s
}
.why-card:hover{
  border-color:var(--terra);
  background:rgba(201,96,58,0.06);
  transform:translateY(-4px)
}
.why-card-num{
  position:absolute;right:16px;top:12px;
  font-family:'Fjalla One',sans-serif;font-size:64px;
  color:rgba(255,255,255,0.04);line-height:1;pointer-events:none
}
.why-card i{font-size:28px;color:var(--terra);margin-bottom:16px;display:block}
.why-card h3{
  font-family:'Fjalla One',sans-serif;font-size:17px;
  text-transform:uppercase;letter-spacing:0.04em;
  color:#fff;margin-bottom:10px
}
.why-card p{font-size:14px;color:rgba(255,255,255,0.45);line-height:1.65;font-weight:300}

/* CONTACT */
.contact{background:var(--bg);padding:100px 48px}
.contact-inner{
  max-width:1200px;margin:0 auto;
  display:grid;grid-template-columns:1fr 1.3fr;gap:80px;align-items:start
}
.contact-left h2{
  font-family:'Fjalla One',sans-serif;
  font-size:clamp(32px,4vw,52px);
  color:var(--text);line-height:1.05;margin-bottom:14px
}
.contact-left h2 em{color:var(--terra);font-style:normal}
.contact-left>p{
  font-size:16px;color:var(--muted);line-height:1.75;
  font-weight:400;margin-bottom:36px;max-width:380px
}
.contact-details{display:flex;flex-direction:column;gap:16px;margin-bottom:36px}
.cd-item{display:flex;align-items:flex-start;gap:14px}
.cd-icon{
  width:44px;height:44px;flex-shrink:0;
  background:var(--cream);border:1px solid var(--border);
  display:flex;align-items:center;justify-content:center;
  color:var(--terra);font-size:15px
}
.cd-item h4{
  font-family:'Fjalla One',sans-serif;font-size:11px;
  letter-spacing:0.12em;text-transform:uppercase;
  color:var(--muted);margin-bottom:2px
}
.cd-item p,.cd-item a{
  font-size:15px;color:var(--text);font-weight:500;
  line-height:1.5;text-decoration:none
}
.cd-item a:hover{color:var(--terra)}

.contact-form{
  background:var(--white);border:1px solid var(--border);
  border-top:4px solid var(--terra);
  padding:44px
}
.cf-title{
  font-family:'Fjalla One',sans-serif;font-size:22px;
  letter-spacing:0.04em;text-transform:uppercase;
  color:var(--text);margin-bottom:6px
}
.cf-sub{font-size:14px;color:var(--muted);font-weight:400;margin-bottom:28px}
.cf-row{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px}
.cf-group{display:flex;flex-direction:column;gap:5px;margin-bottom:12px}
.cf-input,.cf-select,.cf-textarea{
  width:100%;background:var(--bg);border:1px solid var(--border);
  padding:12px 14px;
  font-family:'Source Sans 3',sans-serif;font-size:14px;color:var(--text);
  outline:none;border-radius:0;
  transition:border-color 0.22s
}
.cf-input::placeholder,.cf-textarea::placeholder{color:#b8b2aa}
.cf-input:focus,.cf-select:focus,.cf-textarea:focus{border-color:var(--terra)}
.cf-select{cursor:pointer}
.cf-textarea{resize:vertical;min-height:110px;margin-bottom:12px}
.cf-submit{
  width:100%;background:var(--terra);color:#fff;border:none;
  font-family:'Fjalla One',sans-serif;font-size:15px;
  letter-spacing:0.12em;text-transform:uppercase;
  padding:16px;cursor:pointer;
  display:flex;align-items:center;justify-content:center;gap:10px;
  transition:background 0.2s,transform 0.15s
}
.cf-submit:hover{background:var(--terra-dk);transform:translateY(-1px)}
.cf-note{text-align:center;font-size:11px;color:var(--muted);margin-top:10px}
.cf-note i{color:#16a34a;margin-right:4px}

/* FOOTER */
footer{background:var(--slate);padding:64px 48px 28px;position:relative}
footer::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:var(--terra)}
.footer-grid{
  max-width:1200px;margin:0 auto 52px;
  display:grid;grid-template-columns:1.6fr 1fr 1fr 1fr;gap:48px
}
.footer-logo-txt{
  font-family:'Fjalla One',sans-serif;font-size:20px;
  color:#fff;letter-spacing:0.04em;text-transform:uppercase;
  display:flex;align-items:center;gap:10px;margin-bottom:14px
}
.footer-logo-txt span{color:var(--terra)}
.footer-logo-img{height:32px;width:auto;filter:brightness(0) invert(1) opacity(0.7)}
.footer-brand>p{
  font-size:14px;color:rgba(255,255,255,0.38);
  line-height:1.75;font-weight:300;margin-bottom:20px
}
.footer-col h4{
  font-family:'Fjalla One',sans-serif;font-size:12px;
  letter-spacing:0.14em;text-transform:uppercase;
  color:#fff;margin-bottom:16px;padding-bottom:10px;
  border-bottom:1px solid rgba(255,255,255,0.08)
}
.footer-links{list-style:none;display:flex;flex-direction:column;gap:8px}
.footer-links a,.footer-links li{
  font-size:13px;color:rgba(255,255,255,0.38);
  text-decoration:none;font-weight:300;
  transition:color 0.2s
}
.footer-links a:hover{color:var(--terra)}
.footer-bottom{
  max-width:1200px;margin:0 auto;
  padding-top:24px;border-top:1px solid rgba(255,255,255,0.07);
  display:flex;align-items:center;justify-content:space-between
}
.footer-bottom p{font-size:13px;color:rgba(255,255,255,0.28);font-weight:300}
.footer-tracking{display:none}

/* RESPONSIVE — TABLET */
@media (max-width: 1024px) {
  nav{padding:0 24px}
  .nav-links{gap:20px}
  .hero-inner{grid-template-columns:1fr;max-width:600px;margin:0 auto;
    justify-items:center;text-align:center}
  .hero-eyebrow,.hero-bullets,.hero-cta-row{justify-content:center}
  .hero-sub{margin:0 auto 32px}
  .hero-form-card{width:100%;max-width:500px}
  .hero{min-height:auto}
  .trust-bar{padding:0 24px}
  .trust-item{flex:1 1 50%;min-width:200px}
  .services{padding:80px 32px 148px}
  .services-grid{grid-template-columns:repeat(2,1fr)}
  .stats-inner{flex-wrap:wrap}
  .stat-box{flex:0 0 50%;padding:20px;border-right:none;
    border-bottom:1px solid rgba(255,255,255,0.2)}
  .stat-box:nth-child(odd){border-right:1px solid rgba(255,255,255,0.2)}
  .stat-box:last-child{border-bottom:none}
  .about{padding:80px 32px 148px}
  .about-inner{grid-template-columns:1fr;gap:48px}
  .about-photos{height:360px}
  .testimonials{padding:80px 32px 148px}
  .testi-grid{grid-template-columns:1fr 1fr}
  .why{padding:80px 32px}
  .why-intro{grid-template-columns:1fr;gap:20px;margin-bottom:40px}
  .why-grid{grid-template-columns:1fr 1fr;gap:16px}
  .contact{padding:80px 32px}
  .contact-inner{grid-template-columns:1fr;gap:48px}
  footer{padding:48px 32px 24px}
  .footer-grid{grid-template-columns:1fr 1fr;gap:32px}
}

/* RESPONSIVE — MOBILE */
@media (max-width: 768px) {
  nav{height:60px;padding:0 16px;
    display:flex;justify-content:space-between;grid-template-columns:none}
  .nav-left,.nav-links{display:none}
  .nav-logo{font-size:17px}
  .nav-right{gap:10px}
  .nav-phone{display:none}
  .nav-cta{font-size:12px;padding:7px 14px}
  .hero{margin-top:60px;min-height:auto}
  .hero-inner{padding:40px 20px;grid-template-columns:1fr}
  .hero-h1{font-size:clamp(38px,10vw,58px)}
  .hero-sub{font-size:15px}
  .hero-cta-row{flex-direction:column;align-items:center}
  .hero-phone-link{display:none}
  .trust-bar{padding:0 16px}
  .trust-bar-inner{flex-direction:column}
  .trust-item{border-right:none;border-bottom:1px solid var(--border);padding:16px 20px}
  .trust-item:last-child{border-bottom:none}
  .services{padding:56px 20px 148px}
  .section-head{margin-bottom:36px}
  .services-grid{grid-template-columns:1fr}
  .srv-card{padding:28px 20px}
  .photo-wall{height:220px;grid-template-columns:1fr 1fr}
  .pb-cell:last-child{display:none}
  .stats-strip{padding:36px 20px}
  .stats-inner{flex-wrap:wrap;max-width:100%}
  .stat-box{flex:0 0 50%;padding:14px 8px}
  .stat-num{font-size:40px}
  .about{padding:56px 20px 148px}
  .about-inner{grid-template-columns:1fr;gap:36px}
  .about-photos{height:240px;grid-template-columns:1fr;grid-template-rows:1fr 80px}
  .aph-main{grid-row:auto}
  .aph-sm{display:none}
  .testimonials{padding:56px 20px 148px}
  .testi-grid{grid-template-columns:1fr}
  .why{padding:56px 20px}
  .why-intro{grid-template-columns:1fr;gap:16px;margin-bottom:32px}
  .why-grid{grid-template-columns:1fr;gap:12px}
  .why-card{padding:24px 20px}
  .contact{padding:56px 20px}
  .contact-inner{grid-template-columns:1fr;gap:40px}
  .contact-form{padding:28px 20px}
  .cf-row{grid-template-columns:1fr}
  footer{padding:44px 20px 20px}
  .footer-grid{grid-template-columns:1fr;gap:28px}
  .footer-bottom{flex-direction:column;gap:6px;text-align:center}
  .footer-bottom p{font-size:12px}
}
</style>
</head>
<body>

<a href="#main" class="skip-link">Skip to main content</a>

<nav aria-label="Main navigation">
  <div class="nav-left">
    <ul class="nav-links">
      <li><a href="#services">Services</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="#why">Why Us</a></li>
      <li><a href="#contact">Contact</a></li>
    </ul>
  </div>
  <a href="#" class="nav-logo" aria-label="PLACEHOLDER_COMPANY home">PLACEHOLDER_NAV_LOGO_T6</a>
  <div class="nav-right">
    <a href="tel:PLACEHOLDER_PHONE_DIGITS" class="nav-phone" aria-label="Call us at PLACEHOLDER_PHONE">
      <i class="fa-solid fa-phone" aria-hidden="true"></i> PLACEHOLDER_PHONE
    </a>
    <a href="#contact" class="nav-cta">Free Estimate</a>
  </div>
</nav>

<section class="hero" id="main" aria-label="Hero">
  <div class="hero-bg" role="img" aria-label="Roofers installing shingles on a residential home" style="background-image:url('PLACEHOLDER_IMG/christer-lassman-G2J41LRaKkE-unsplash.jpg');background-position:center;background-size:cover"></div>
  <div class="hero-overlay" aria-hidden="true"></div>
  <div class="hero-inner">
    <div class="hero-left">
      <div class="hero-eyebrow">PLACEHOLDER_HERO_EYEBROW</div>
      <h1 class="hero-h1">PLACEHOLDER_HERO_H1</h1>
      <p class="hero-sub">PLACEHOLDER_HERO_TAGLINE</p>
      <ul class="hero-bullets" aria-label="Key credentials">
        <li><i class="fa-solid fa-shield-halved" aria-hidden="true"></i> Licensed, bonded, and fully insured</li>
        <li><i class="fa-solid fa-certificate" aria-hidden="true"></i> GAF Master Elite Certified</li>
        <li><i class="fa-solid fa-star" aria-hidden="true"></i> 5-star rated on Google</li>
      </ul>
      <div class="hero-cta-row">
        <a href="#contact" class="hero-btn"><i class="fa-solid fa-clipboard-check" aria-hidden="true"></i> Get Free Estimate</a>
        <a href="tel:PLACEHOLDER_PHONE_DIGITS" class="hero-phone-link" aria-label="Call PLACEHOLDER_PHONE">
          <i class="fa-solid fa-phone" aria-hidden="true"></i> PLACEHOLDER_PHONE
        </a>
      </div>
    </div>

    <div class="hero-form-card" role="form" aria-label="Request a free estimate">
      <div class="hfc-title">Free Roof Estimate</div>
      <p class="hfc-sub">We'll schedule your inspection within 48 hours. No pressure, no obligation.</p>
      <div class="hf-row">
        <div class="hf-group">
          <label for="hf-fname">First Name <span aria-hidden="true" style="color:var(--terra)">*</span></label>
          <input class="hf-input" type="text" id="hf-fname" name="fname" autocomplete="given-name" placeholder="First Name" required>
        </div>
        <div class="hf-group">
          <label for="hf-lname">Last Name <span aria-hidden="true" style="color:var(--terra)">*</span></label>
          <input class="hf-input" type="text" id="hf-lname" name="lname" autocomplete="family-name" placeholder="Last Name" required>
        </div>
      </div>
      <div class="hf-row">
        <div class="hf-group">
          <label for="hf-email">Email <span aria-hidden="true" style="color:var(--terra)">*</span></label>
          <input class="hf-input" type="email" id="hf-email" name="email" autocomplete="email" placeholder="you@email.com" required>
        </div>
        <div class="hf-group">
          <label for="hf-phone">Phone <span style="font-weight:400;color:var(--muted)">(optional)</span></label>
          <input class="hf-input" type="tel" id="hf-phone" name="tel" autocomplete="tel" placeholder="(330) 555-0000">
        </div>
      </div>
      <div class="hf-group">
        <label for="hf-service">What Do You Need? <span aria-hidden="true" style="color:var(--terra)">*</span></label>
        <select class="hf-select" id="hf-service" name="service" required>
          <option value="" disabled selected>Select a service</option>
          <option>Full Roof Replacement</option>
          <option>Leak Repair</option>
          <option>Storm Damage Assessment</option>
          <option>Commercial Roofing</option>
          <option>Gutters &amp; Fascia</option>
          <option>Free Inspection</option>
          <option>Other</option>
        </select>
      </div>
      <div class="hf-group">
        <label for="hf-address">Property Address <span style="font-weight:400;color:var(--muted)">(optional)</span></label>
        <input class="hf-input" type="text" id="hf-address" name="address" autocomplete="street-address" placeholder="123 Main St">
      </div>
      <button class="hf-submit" type="button">
        <i class="fa-solid fa-arrow-right" aria-hidden="true"></i> Request Free Estimate
      </button>
      <p class="hf-note"><i class="fa-solid fa-lock" aria-hidden="true"></i> Your info is never shared. We respond within 24 hours.</p>
    </div>
  </div>
</section>

<div class="trust-bar" aria-label="Key credentials">
  <div class="trust-bar-inner">
    <div class="trust-item anim d1">
      <div class="trust-icon" aria-hidden="true"><i class="fa-solid fa-shield-halved"></i></div>
      <div><h4>Licensed &amp; Insured</h4><p>Ohio contractor license, full liability and workers' comp</p></div>
    </div>
    <div class="trust-item anim d2">
      <div class="trust-icon" aria-hidden="true"><i class="fa-solid fa-certificate"></i></div>
      <div><h4>GAF Master Elite</h4><p>Top 3% of roofing contractors nationwide</p></div>
    </div>
    <div class="trust-item anim d3">
      <div class="trust-icon" aria-hidden="true"><i class="fa-solid fa-file-contract"></i></div>
      <div><h4>Insurance Experts</h4><p>We document and work directly with your adjuster</p></div>
    </div>
    <div class="trust-item anim d4">
      <div class="trust-icon" aria-hidden="true"><i class="fa-solid fa-magnifying-glass"></i></div>
      <div><h4>Free Inspections</h4><p>No-pressure assessments with detailed photo reports</p></div>
    </div>
  </div>
</div>

<section class="services" id="services">
  <div class="section-head">
    <div class="sec-label anim">What We Do</div>
    <h2 class="sec-h2 anim d1">Roofing Services Built <em>on Reputation</em></h2>
    <p class="sec-sub anim d2">From the first shingle to the final inspection, we handle every aspect of your roof with the same care we'd give our own home.</p>
  </div>
  <div class="services-grid">
    PLACEHOLDER_SERVICE_CARDS_T6
  </div>
</section>

<div class="photo-wall" aria-hidden="true">
  <div class="pb-cell">
    <img src="PLACEHOLDER_IMG/pexels-william-mead-106275-6040783.jpg" alt="" loading="lazy">
    <div class="pb-overlay"></div>
  </div>
  <div class="pb-cell">
    <img src="PLACEHOLDER_IMG/chandler-cruttenden-dDluNWaVQWA-unsplash.jpg" alt="" loading="lazy">
    <div class="pb-overlay"></div>
  </div>
  <div class="pb-cell">
    <img src="PLACEHOLDER_IMG/pexels-caspar-roofing-channel-3522832-5264825.jpg" alt="" loading="lazy">
    <div class="pb-overlay"></div>
  </div>
</div>

<div class="stats-strip">
  <div class="stats-inner">
    <div class="stat-box anim d1"><span class="stat-num">35+</span><span class="stat-lbl">Years in Business</span></div>
    <div class="stat-box anim d2"><span class="stat-num">4,200+</span><span class="stat-lbl">Roofs Completed</span></div>
    <div class="stat-box anim d3"><span class="stat-num">5.0</span><span class="stat-lbl">Google Rating</span></div>
    <div class="stat-box anim d4"><span class="stat-num">100%</span><span class="stat-lbl">Licensed &amp; Insured</span></div>
  </div>
</div>

<section class="about" id="about">
  <div class="about-inner">
    <div class="about-photos anim left">
      <div class="aph-main">
        <img src="PLACEHOLDER_IMG/raze-solar-Scaj0T40nFI-unsplash.jpg" alt="Roofer at work" loading="lazy">
      </div>
      <div class="aph-sm">
        <img src="PLACEHOLDER_IMG/pexels-florida-solar-fix-2154752009-33379360.jpg" alt="Roofing detail work" loading="lazy">
      </div>
      <div class="aph-stat">
        <strong>$0</strong>
        <span>Inspection Fee</span>
      </div>
    </div>
    <div class="about-content">
      <div class="sec-label anim">About Us</div>
      <h2 class="anim d1">Craftsmen Who Take <em>Pride</em> in Their Work</h2>
      <p class="anim d2">PLACEHOLDER_ABOUT_PARA</p>
      <ul class="about-checklist">
        <li class="anim d2"><i class="fa-solid fa-check" aria-hidden="true"></i> GAF Master Elite Certified contractor</li>
        <li class="anim d3"><i class="fa-solid fa-check" aria-hidden="true"></i> Full Ohio contractor license and insurance</li>
        <li class="anim d4"><i class="fa-solid fa-check" aria-hidden="true"></i> Lifetime workmanship warranty on all installs</li>
        <li class="anim d5"><i class="fa-solid fa-check" aria-hidden="true"></i> Insurance claim documentation specialists</li>
        <li class="anim d6"><i class="fa-solid fa-check" aria-hidden="true"></i> Free inspections, no pressure, no obligation</li>
      </ul>
      <div class="cert-row anim d2">
        <span class="cert-tag">GAF Master Elite</span>
        <span class="cert-tag">Owens Corning Preferred</span>
        <span class="cert-tag">BBB Accredited</span>
        <span class="cert-tag">Free Inspections</span>
      </div>
      <a href="#contact" class="btn-terra anim d3"><i class="fa-solid fa-clipboard-check" aria-hidden="true"></i> Get Your Free Estimate</a>
    </div>
  </div>
</section>

<section class="testimonials" aria-labelledby="testi-heading">
  <div class="section-head">
    <div class="sec-label anim">Customer Reviews</div>
    <h2 class="sec-h2 anim d1" id="testi-heading">What Homeowners <em>Say About Us</em></h2>
    <p class="sec-sub anim d2">We let our work speak for itself. Here's what real homeowners say about us.</p>
  </div>
  <div class="testi-grid">
    <div class="testi-card anim d1">
      <div class="testi-stars" aria-label="5 out of 5 stars">
        <i class="fa-solid fa-star" aria-hidden="true"></i><i class="fa-solid fa-star" aria-hidden="true"></i>
        <i class="fa-solid fa-star" aria-hidden="true"></i><i class="fa-solid fa-star" aria-hidden="true"></i>
        <i class="fa-solid fa-star" aria-hidden="true"></i>
      </div>
      <p class="testi-text">"After the hailstorm last spring, I called three roofers. They were the only one who came out same-day, documented everything, and handled the insurance claim from start to finish. The roof looks incredible."</p>
      <div class="testi-author">
        <div class="testi-avatar" aria-hidden="true">KM</div>
        <div>
          <span class="testi-name">Karen M.</span>
          <span class="testi-meta">Verified Google Review</span>
        </div>
      </div>
    </div>
    <div class="testi-card anim d2">
      <div class="testi-stars" aria-label="5 out of 5 stars">
        <i class="fa-solid fa-star" aria-hidden="true"></i><i class="fa-solid fa-star" aria-hidden="true"></i>
        <i class="fa-solid fa-star" aria-hidden="true"></i><i class="fa-solid fa-star" aria-hidden="true"></i>
        <i class="fa-solid fa-star" aria-hidden="true"></i>
      </div>
      <p class="testi-text">"We had a persistent leak that two other contractors couldn't fix. They found it on the first visit, explained exactly what was wrong, and had it sealed within a week. Zero leaks since. Worth every penny."</p>
      <div class="testi-author">
        <div class="testi-avatar" aria-hidden="true">TP</div>
        <div>
          <span class="testi-name">Tom P.</span>
          <span class="testi-meta">Verified Google Review</span>
        </div>
      </div>
    </div>
    <div class="testi-card anim d3">
      <div class="testi-stars" aria-label="5 out of 5 stars">
        <i class="fa-solid fa-star" aria-hidden="true"></i><i class="fa-solid fa-star" aria-hidden="true"></i>
        <i class="fa-solid fa-star" aria-hidden="true"></i><i class="fa-solid fa-star" aria-hidden="true"></i>
        <i class="fa-solid fa-star" aria-hidden="true"></i>
      </div>
      <p class="testi-text">"Full replacement on a 3,000 sq ft house. The crew arrived early, cleaned up completely every evening, and finished two days ahead of schedule. Neighbors stopped to ask who did it. Highest recommendation."</p>
      <div class="testi-author">
        <div class="testi-avatar" aria-hidden="true">DW</div>
        <div>
          <span class="testi-name">Diane W.</span>
          <span class="testi-meta">Verified Google Review</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="why" id="why">
  <div class="why-inner">
    <div class="why-intro">
      <div>
        <div class="sec-label anim" style="color:rgba(255,255,255,0.5)">Why Choose Us</div>
        <h2 class="anim d1">The <em>Difference</em></h2>
      </div>
      <p class="anim d1">Four reasons homeowners choose us over every other contractor on the list, and why they keep coming back.</p>
    </div>
    <div class="why-grid">
      <div class="why-card anim d1">
        <div class="why-card-num" aria-hidden="true">01</div>
        <i class="fa-solid fa-file-invoice-dollar" aria-hidden="true"></i>
        <h3>Transparent Pricing</h3>
        <p>You get a detailed line-item estimate before anything starts. No surprises, no change orders after the fact. The price we quote is the price you pay.</p>
      </div>
      <div class="why-card anim d2">
        <div class="why-card-num" aria-hidden="true">02</div>
        <i class="fa-solid fa-bolt" aria-hidden="true"></i>
        <h3>Fast Response</h3>
        <p>Same-day emergency tarping, 48-hour inspection scheduling, and no-delay job starts once materials arrive. We move when you need us to move.</p>
      </div>
      <div class="why-card anim d3">
        <div class="why-card-num" aria-hidden="true">03</div>
        <i class="fa-solid fa-medal" aria-hidden="true"></i>
        <h3>Lifetime Warranty</h3>
        <p>Every install is backed by our lifetime workmanship warranty on top of the manufacturer warranty. If it fails, we come back and make it right.</p>
      </div>
      <div class="why-card anim d4">
        <div class="why-card-num" aria-hidden="true">04</div>
        <i class="fa-solid fa-handshake" aria-hidden="true"></i>
        <h3>Insurance Experts</h3>
        <p>We've handled hundreds of insurance claims. We document the damage, communicate with your adjuster, and fight to get you the full settlement you deserve.</p>
      </div>
    </div>
  </div>
</section>

<section class="contact" id="contact">
  <div class="contact-inner">
    <div class="contact-left">
      <h2 class="anim left">Ready to Protect <em>Your Home?</em></h2>
      <p class="anim left d1">Call or fill out the form and we'll schedule your free inspection within 48 hours. No pressure, no obligation, just an honest assessment.</p>
      <div class="contact-details">
        <div class="cd-item anim d1">
          <div class="cd-icon" aria-hidden="true"><i class="fa-solid fa-phone"></i></div>
          <div><h4>Phone</h4><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></div>
        </div>
        <div class="cd-item anim d2">
          <div class="cd-icon" aria-hidden="true"><i class="fa-solid fa-envelope"></i></div>
          <div><h4>Email</h4><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></div>
        </div>
        <div class="cd-item anim d3">
          <div class="cd-icon" aria-hidden="true"><i class="fa-solid fa-location-dot"></i></div>
          <div><h4>Address</h4><p>PLACEHOLDER_ADDRESS</p></div>
        </div>
      </div>
    </div>
    <div class="contact-form anim right">
      <div class="cf-title">Request Service</div>
      <p class="cf-sub">Fill out the form and we'll contact you to schedule your free inspection.</p>
      <div class="cf-row">
        <div class="cf-group">
          <label class="sr-only" for="cf-fname">First Name</label>
          <input class="cf-input" type="text" id="cf-fname" name="fname" autocomplete="given-name" placeholder="First Name">
        </div>
        <div class="cf-group">
          <label class="sr-only" for="cf-lname">Last Name</label>
          <input class="cf-input" type="text" id="cf-lname" name="lname" autocomplete="family-name" placeholder="Last Name">
        </div>
      </div>
      <div class="cf-row" style="margin-bottom:12px">
        <div class="cf-group">
          <label class="sr-only" for="cf-phone">Phone Number</label>
          <input class="cf-input" type="tel" id="cf-phone" name="phone" autocomplete="tel" placeholder="Phone Number">
        </div>
        <div class="cf-group">
          <label class="sr-only" for="cf-email">Email Address</label>
          <input class="cf-input" type="email" id="cf-email" name="email" autocomplete="email" placeholder="Email Address">
        </div>
      </div>
      <div class="cf-group">
        <label class="sr-only" for="cf-service">Service Needed</label>
        <select class="cf-select" id="cf-service" name="service" style="margin-bottom:0">
          <option value="" disabled selected>Service Needed</option>
          <option>Full Roof Replacement</option>
          <option>Leak Repair</option>
          <option>Storm Damage Repair</option>
          <option>Commercial Roofing</option>
          <option>Gutters &amp; Fascia</option>
          <option>Free Inspection</option>
          <option>Other</option>
        </select>
      </div>
      <div style="margin-top:12px">
        <label class="sr-only" for="cf-message">Describe the Issue</label>
        <textarea class="cf-textarea" id="cf-message" name="message" placeholder="Describe your roof issue or project..."></textarea>
      </div>
      <button class="cf-submit" type="button">
        <i class="fa-solid fa-paper-plane" aria-hidden="true"></i> Send My Request
      </button>
      <p class="cf-note"><i class="fa-solid fa-lock" aria-hidden="true"></i> We'll never share your information. Response within 24 hours.</p>
    </div>
  </div>
</section>

<footer>
  <div class="footer-grid">
    <div class="footer-brand">
      <div class="footer-logo-txt">PLACEHOLDER_FOOTER_LOGO_T6</div>
      <p>Licensed, insured, and built on a reputation for quality craftsmanship. Your home deserves the best.</p>
    </div>
    <div class="footer-col">
      <h4>Services</h4>
      <ul class="footer-links">
        <li><a href="#services">Full Roof Replacement</a></li>
        <li><a href="#services">Leak Repairs</a></li>
        <li><a href="#services">Storm Damage Repair</a></li>
        <li><a href="#services">Commercial Roofing</a></li>
        <li><a href="#services">Gutters &amp; Fascia</a></li>
        <li><a href="#contact">Free Inspections</a></li>
      </ul>
    </div>
    <div class="footer-col">
      <h4>Company</h4>
      <ul class="footer-links">
        <li><a href="#about">About Us</a></li>
        <li><a href="#why">Why Choose Us</a></li>
        <li><a href="#contact">Free Estimate</a></li>
        <li><a href="#contact">Contact Us</a></li>
      </ul>
    </div>
    <div class="footer-col">
      <h4>Contact</h4>
      <ul class="footer-links">
        <li><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></li>
        <li><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></li>
        <li>PLACEHOLDER_ADDRESS</li>
        <li>Emergency Line: 24/7</li>
      </ul>
    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; 2025 PLACEHOLDER_COMPANY. All rights reserved.</p>
    <p>Licensed Roofing Contractor &bull; GAF Master Elite Certified</p>
  </div>
</footer>

<div class="footer-tracking">PLACEHOLDER_TRACKING</div>

<script>
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (prefersReducedMotion) {
  document.querySelectorAll('.anim').forEach(el => el.classList.add('on'));
} else {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('on'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.anim').forEach(el => observer.observe(el));

  function animateCounter(el) {
    const raw = el.textContent;
    const target = parseFloat(raw.replace(/[^0-9.]/g, ''));
    const suffix = raw.replace(/[0-9.]/g, '').trim();
    const isFloat = raw.includes('.');
    const duration = 1800;
    const start = performance.now();
    function step(now) {
      const progress = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      const val = target * ease;
      el.textContent = (isFloat ? val.toFixed(1) : Math.round(val)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        animateCounter(e.target);
        counterObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.stat-num').forEach(el => counterObserver.observe(el));
}
</script>
</body>
</html>`;


// ─── T7: "Stormguard" ────────────────────────────────────────────────────────
const T7 = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>PLACEHOLDER_COMPANY | Storm Damage Roofing</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=Barlow:wght@300;400;500&display=swap" rel="stylesheet">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css">
<style>
  PLACEHOLDER_BRAND_COLORS_T7
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { font-family: 'Barlow', sans-serif; background: var(--bg); color: var(--text); overflow-x: hidden; }

  /* SCROLL ANIMATIONS */
  .anim { opacity: 0; transform: translateY(28px); transition: opacity 0.6s ease, transform 0.6s ease; }
  .anim.left { transform: translateX(-28px); }
  .anim.right { transform: translateX(28px); }
  .anim.on { opacity: 1; transform: none; }
  .d1 { transition-delay: 0.05s; } .d2 { transition-delay: 0.12s; } .d3 { transition-delay: 0.19s; }
  .d4 { transition-delay: 0.26s; } .d5 { transition-delay: 0.33s; } .d6 { transition-delay: 0.40s; }

  /* ALERT BANNER */
  .alert-banner {
    background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 14px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase;
    text-align: center; padding: 10px 24px;
    display: flex; align-items: center; justify-content: center; gap: 24px;
  }
  .alert-banner a { color: #000; text-decoration: none; border-bottom: 1px solid rgba(0,0,0,0.4); }
  .alert-dot { width: 8px; height: 8px; background: #000; border-radius: 50%; animation: blink 1s ease-in-out infinite; }
  @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.25} }

  /* NAV */
  nav {
    position: sticky; top: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 64px; height: 64px;
    background: var(--bg); border-bottom: 2px solid var(--yellow);
  }
  .nav-logo {
    font-family: 'Barlow Condensed', sans-serif; font-size: 24px; font-weight: 800;
    color: var(--text); letter-spacing: 0.04em; text-transform: uppercase;
    display: flex; align-items: center; gap: 12px;
  }
  .nav-logo-img { height: 36px; width: auto; filter: brightness(0) invert(1); }
  .nav-links { display: flex; gap: 36px; list-style: none; }
  .nav-links a {
    font-family: 'Barlow Condensed', sans-serif; font-size: 15px; font-weight: 600;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: rgba(255,255,255,0.5); text-decoration: none; transition: color 0.2s;
  }
  .nav-links a:hover { color: var(--yellow); }
  .nav-cta {
    background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif; font-size: 14px; font-weight: 800;
    letter-spacing: 0.14em; text-transform: uppercase;
    padding: 10px 24px; border: none; cursor: pointer; text-decoration: none;
    transition: opacity 0.2s;
  }
  .nav-cta:hover { opacity: 0.85; }

  /* HERO */
  .hero {
    position: relative; min-height: 92vh;
    display: grid; grid-template-columns: 1.05fr 0.95fr;
    overflow: hidden;
  }
  .hero-left {
    position: relative; z-index: 2;
    display: flex; flex-direction: column; justify-content: center;
    padding: 72px 56px 72px 64px;
    background: var(--bg);
  }
  .hero-left::after {
    content: ''; position: absolute; top: 0; right: -6px;
    width: 6px; height: 100%; background: var(--yellow); z-index: 3;
  }
  .hero-right {
    position: relative; overflow: hidden;
    background: var(--surface);
    clip-path: polygon(8% 0, 100% 0, 100% 100%, 0% 100%);
  }
  /* Gradient photo placeholder for hero right */
  .hero-photo-bg {
    position: absolute; inset: 0;
    background: linear-gradient(155deg, #1a1f28 0%, #0f1420 40%, #1c2030 100%);
    display: flex; align-items: center; justify-content: center;
  }
  .hero-photo-bg i { font-size: 120px; color: rgba(234, 179, 8, 0.06); }
  .hero-photo-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(270deg, transparent 30%, rgba(12,15,20,0.8) 100%);
  }

  /* Stat boxes overlay on hero right */
  .hero-stat-grid {
    position: absolute; bottom: 48px; right: 48px;
    display: grid; grid-template-columns: 1fr 1fr; gap: 2px; z-index: 4;
  }
  .stat-box {
    background: rgba(12, 15, 20, 0.9);
    padding: 20px 22px; border-bottom: 2px solid var(--yellow);
    backdrop-filter: blur(8px);
  }
  .stat-num-big {
    font-family: 'Barlow Condensed', sans-serif; font-size: 42px; font-weight: 900;
    color: var(--yellow); line-height: 1; display: block;
  }
  .stat-label-sm {
    font-size: 11px; font-weight: 500; letter-spacing: 0.06em; text-transform: uppercase;
    color: rgba(255,255,255,0.5); margin-top: 3px;
  }

  .hero-label {
    display: inline-flex; align-items: center; gap: 10px;
    background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif; font-size: 12px; font-weight: 800;
    letter-spacing: 0.18em; text-transform: uppercase;
    padding: 6px 14px; margin-bottom: 24px;
    width: fit-content;
  }
  .hero-h1 {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: clamp(50px, 6.5vw, 84px); font-weight: 900; line-height: 0.95;
    text-transform: uppercase; color: var(--text); letter-spacing: -0.01em;
    margin-bottom: 20px;
  }
  .hero-h1 span { color: var(--yellow); display: block; }
  .hero-tagline {
    font-size: 17px; line-height: 1.65; color: rgba(255,255,255,0.55);
    font-weight: 300; margin-bottom: 36px; max-width: 480px;
  }

  /* Hero quick form */
  .hero-form {
    background: rgba(255,255,255,0.04); border: 1px solid rgba(234,179,8,0.25);
    border-top: 3px solid var(--yellow); padding: 24px; max-width: 480px;
  }
  .hero-form-title {
    font-family: 'Barlow Condensed', sans-serif; font-size: 16px; font-weight: 700;
    letter-spacing: 0.08em; text-transform: uppercase; color: var(--text); margin-bottom: 14px;
  }
  .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 8px; }
  .form-row.full { grid-template-columns: 1fr; }
  .hero-form input, .hero-form select {
    width: 100%; padding: 10px 13px;
    background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12);
    color: var(--text); font-family: 'Barlow', sans-serif; font-size: 14px;
    outline: none; transition: border-color 0.2s;
  }
  .hero-form input::placeholder { color: rgba(255,255,255,0.3); }
  .hero-form input:focus, .hero-form select:focus { border-color: var(--yellow); }
  .hero-form select { color: rgba(255,255,255,0.5); }
  .hero-form select option { background: #0c0f14; color: var(--text); }
  .form-submit {
    width: 100%; padding: 13px; margin-top: 4px;
    background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif; font-size: 15px; font-weight: 800;
    letter-spacing: 0.12em; text-transform: uppercase;
    border: none; cursor: pointer; transition: opacity 0.2s;
  }
  .form-submit:hover { opacity: 0.88; }

  /* TRUST BAR */
  .trust-bar {
    background: rgba(234,179,8,0.08); border-top: 1px solid rgba(234,179,8,0.2);
    border-bottom: 1px solid rgba(234,179,8,0.2);
    padding: 16px 64px;
    display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 20px;
  }
  .trust-item {
    display: flex; align-items: center; gap: 10px;
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 14px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase;
    color: rgba(255,255,255,0.65);
  }
  .trust-item i { color: var(--yellow); font-size: 16px; }

  /* SERVICES */
  .services { background: var(--surface); padding: 100px 64px; }
  .services-header {
    display: flex; align-items: flex-end; justify-content: space-between;
    max-width: 1200px; margin: 0 auto 56px;
    border-bottom: 1px solid rgba(234,179,8,0.2); padding-bottom: 28px;
  }
  .services-header h2 {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: clamp(34px, 5vw, 58px); font-weight: 900; text-transform: uppercase;
    color: var(--text); line-height: 1;
  }
  .services-header h2 em { color: var(--yellow); font-style: normal; }
  .services-header p { font-size: 15px; color: rgba(255,255,255,0.45); max-width: 260px; text-align: right; line-height: 1.6; }
  .srv-grid {
    display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px;
    max-width: 1200px; margin: 0 auto;
  }
  .srv-card {
    background: var(--bg); padding: 32px 28px;
    position: relative; overflow: hidden; transition: background 0.25s;
  }
  .srv-card::before {
    content: ''; position: absolute; top: 0; left: 0;
    width: 0; height: 3px; background: var(--yellow); transition: width 0.35s ease;
  }
  .srv-card:hover { background: rgba(234,179,8,0.04); }
  .srv-card:hover::before { width: 100%; }
  .card-num {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 64px; font-weight: 900; line-height: 1;
    color: rgba(234,179,8,0.07); margin-bottom: -16px;
    letter-spacing: -0.02em;
  }
  .card-icon { font-size: 26px; color: var(--yellow); margin-bottom: 12px; display: block; }
  .srv-card h3 {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: 22px; font-weight: 700; text-transform: uppercase;
    color: var(--text); margin-bottom: 10px; letter-spacing: 0.04em;
  }
  .srv-card p { font-size: 14px; color: rgba(255,255,255,0.45); line-height: 1.6; font-weight: 300; }

  /* PHOTO WALL */
  .photo-wall { display: grid; grid-template-columns: 1fr 1fr 1fr; height: 380px; }
  .pw-cell { position: relative; overflow: hidden; }
  .pw-cell:nth-child(1) { background: linear-gradient(155deg, #141c28 0%, #0f1520 100%); }
  .pw-cell:nth-child(2) { background: linear-gradient(200deg, #0f1520 0%, #1a2030 100%); }
  .pw-cell:nth-child(3) { background: linear-gradient(140deg, #181f2e 0%, #0f1420 100%); }
  .pw-cell .pw-icon {
    position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
    font-size: 52px; color: rgba(234,179,8,0.08);
  }
  .pw-cell::after {
    content: ''; position: absolute; inset: 0;
    background: linear-gradient(180deg, transparent 30%, rgba(12,15,20,0.5) 100%);
  }

  /* STATS STRIP */
  .stats-strip {
    background: var(--yellow); padding: 56px 64px;
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 0;
  }
  .stat-item { text-align: center; padding: 0 20px; border-right: 1px solid rgba(0,0,0,0.15); }
  .stat-item:last-child { border-right: none; }
  .stat-num {
    font-family: 'Barlow Condensed', sans-serif; font-size: 60px; font-weight: 900;
    color: #000; line-height: 1; display: block; margin-bottom: 6px;
  }
  .stat-label {
    font-family: 'Barlow Condensed', sans-serif; font-size: 13px; font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase; color: rgba(0,0,0,0.6);
  }

  /* ABOUT */
  .about { background: var(--bg); padding: 100px 64px; }
  .about-inner {
    max-width: 1200px; margin: 0 auto;
    display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center;
  }
  .about-label {
    display: inline-flex; background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif; font-size: 11px; font-weight: 800;
    letter-spacing: 0.18em; text-transform: uppercase;
    padding: 5px 12px; margin-bottom: 20px;
  }
  .about-content h2 {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: clamp(34px, 4.5vw, 54px); font-weight: 900; text-transform: uppercase;
    color: var(--text); line-height: 1; margin-bottom: 20px;
  }
  .about-content h2 em { color: var(--yellow); font-style: normal; }
  .about-content p {
    font-size: 16px; color: rgba(255,255,255,0.55);
    line-height: 1.75; font-weight: 300; margin-bottom: 28px;
  }
  .promise-list { list-style: none; display: flex; flex-direction: column; gap: 11px; margin-bottom: 36px; }
  .promise-list li {
    font-size: 15px; color: rgba(255,255,255,0.75);
    display: flex; align-items: center; gap: 12px; font-weight: 400;
  }
  .promise-list li::before {
    content: ''; display: flex; align-items: center; justify-content: center;
    width: 20px; height: 20px; flex-shrink: 0;
    background: var(--yellow); color: #000; font-size: 11px; font-weight: 900;
  }
  .promise-list li i { color: var(--yellow); font-size: 13px; flex-shrink: 0; }
  .btn-yellow {
    background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif; font-size: 16px; font-weight: 800;
    letter-spacing: 0.12em; text-transform: uppercase;
    padding: 16px 36px; border: none; cursor: pointer; text-decoration: none;
    display: inline-block; transition: opacity 0.2s, transform 0.15s;
  }
  .btn-yellow:hover { opacity: 0.88; transform: translateY(-2px); }

  .about-visual { display: flex; flex-direction: column; gap: 0; }
  .about-photo-main {
    width: 100%; aspect-ratio: 16/10;
    background: linear-gradient(155deg, #1a1f2e 0%, #111620 50%, #1c2030 100%);
    position: relative; overflow: hidden;
    display: flex; align-items: center; justify-content: center;
  }
  .about-photo-main i { font-size: 80px; color: rgba(234,179,8,0.08); }
  .about-tagline-box {
    background: var(--yellow); padding: 20px 24px;
    font-family: 'Barlow Condensed', sans-serif; font-size: 20px; font-weight: 800;
    text-transform: uppercase; color: #000; letter-spacing: 0.04em; line-height: 1.3;
  }

  /* CONTACT FORM */
  .contact { background: var(--surface); padding: 100px 64px; }
  .contact-inner { max-width: 820px; margin: 0 auto; }
  .contact-hdr { text-align: center; margin-bottom: 48px; }
  .contact-hdr .eyebrow {
    font-family: 'Barlow Condensed', sans-serif; font-size: 12px; font-weight: 800;
    letter-spacing: 0.2em; text-transform: uppercase; color: var(--yellow); margin-bottom: 12px;
  }
  .contact-hdr h2 {
    font-family: 'Barlow Condensed', sans-serif;
    font-size: clamp(32px, 5vw, 52px); font-weight: 900; text-transform: uppercase;
    color: var(--text); line-height: 1;
  }
  .contact-form { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .contact-form .full { grid-column: 1 / -1; }
  .contact-form input, .contact-form select, .contact-form textarea {
    width: 100%; padding: 13px 16px;
    background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
    color: var(--text); font-family: 'Barlow', sans-serif; font-size: 14px;
    outline: none; transition: border-color 0.2s; resize: vertical;
  }
  .contact-form input::placeholder, .contact-form textarea::placeholder { color: rgba(255,255,255,0.25); }
  .contact-form input:focus, .contact-form select:focus, .contact-form textarea:focus { border-color: var(--yellow); }
  .contact-form select { color: rgba(255,255,255,0.45); }
  .contact-form select option { background: #14181f; color: var(--text); }
  .contact-form textarea { min-height: 100px; }
  .contact-submit {
    grid-column: 1 / -1; padding: 16px;
    background: var(--yellow); color: #000;
    font-family: 'Barlow Condensed', sans-serif; font-size: 16px; font-weight: 800;
    letter-spacing: 0.14em; text-transform: uppercase;
    border: none; cursor: pointer; transition: opacity 0.2s;
  }
  .contact-submit:hover { opacity: 0.88; }
  .contact-info {
    display: flex; justify-content: center; gap: 48px; margin-top: 32px; flex-wrap: wrap;
  }
  .contact-info-item {
    display: flex; align-items: center; gap: 10px;
    font-family: 'Barlow Condensed', sans-serif; font-size: 15px; font-weight: 600;
    color: rgba(255,255,255,0.5); letter-spacing: 0.04em;
  }
  .contact-info-item i { color: var(--yellow); font-size: 15px; }
  .contact-info-item a { color: rgba(255,255,255,0.7); text-decoration: none; transition: color 0.2s; }
  .contact-info-item a:hover { color: var(--yellow); }

  /* FOOTER */
  footer { background: #060709; padding: 56px 64px 36px; border-top: 2px solid var(--yellow); }
  .footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 48px; margin-bottom: 40px; }
  .footer-brand .footer-logo {
    font-family: 'Barlow Condensed', sans-serif; font-size: 22px; font-weight: 800;
    text-transform: uppercase; letter-spacing: 0.04em;
    color: var(--text); display: flex; align-items: center; gap: 10px; margin-bottom: 14px;
  }
  .footer-brand .footer-logo-img { height: 32px; width: auto; filter: brightness(0) invert(1) opacity(0.7); }
  .footer-brand p { font-size: 13px; color: rgba(255,255,255,0.35); line-height: 1.65; font-weight: 300; max-width: 260px; }
  .footer-col h4 {
    font-family: 'Barlow Condensed', sans-serif; font-size: 12px; font-weight: 800;
    letter-spacing: 0.16em; text-transform: uppercase; color: var(--yellow); margin-bottom: 16px;
  }
  .footer-col ul { list-style: none; display: flex; flex-direction: column; gap: 9px; }
  .footer-col ul li a {
    font-size: 13px; color: rgba(255,255,255,0.38); text-decoration: none; transition: color 0.2s;
  }
  .footer-col ul li a:hover { color: var(--yellow); }
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.07); padding-top: 20px;
    display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px;
  }
  .footer-bottom p { font-size: 12px; color: rgba(255,255,255,0.22); }
  .footer-tracking { display: none; }

  /* RESPONSIVE */
  @media (max-width: 1024px) {
    .hero { grid-template-columns: 1fr; min-height: auto; }
    .hero-right { height: 300px; clip-path: none; }
    .hero-left { padding: 32px 48px 48px; }
    .hero-left::after { display: none; }
    .hero-stat-grid { right: 24px; bottom: 24px; }
    .about-inner { grid-template-columns: 1fr; gap: 48px; }
    .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
    .stats-strip { grid-template-columns: repeat(2, 1fr); padding: 48px 32px; }
  }
  @media (max-width: 768px) {
    nav { padding: 0 24px; }
    .nav-links { display: none; }
    .trust-bar { padding: 16px 24px; gap: 14px; }
    .services, .about, .contact { padding: 72px 24px; }
    .srv-grid { grid-template-columns: 1fr; }
    .photo-wall { height: 240px; }
    .stats-strip { padding: 40px 24px; gap: 24px; }
    .stat-item { border-right: none; padding: 0; }
    .contact-form { grid-template-columns: 1fr; }
    .contact-form .full { grid-column: 1; }
    .footer-grid { grid-template-columns: 1fr; gap: 28px; }
    .footer-bottom { flex-direction: column; text-align: center; }
  }
</style>
</head>
<body>

<div class="alert-banner">
  <div class="alert-dot"></div>
  24/7 Storm Emergency Line — Call Now: <a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a>
  <div class="alert-dot"></div>
</div>

<nav>
  <div class="nav-logo">
    PLACEHOLDER_NAV_LOGO_T7
  </div>
  <ul class="nav-links">
    <li><a href="#services">Services</a></li>
    <li><a href="#about">About</a></li>
    <li><a href="#contact">Contact</a></li>
  </ul>
  <a href="#contact" class="nav-cta">Free Inspection</a>
</nav>

<section class="hero">
  <div class="hero-left">
    <div class="hero-label">
      <i class="fa-solid fa-bolt"></i> PLACEHOLDER_HERO_EYEBROW
    </div>
    <h1 class="hero-h1">PLACEHOLDER_HERO_H1_LINE1<span>PLACEHOLDER_HERO_H1_LINE2</span></h1>
    <p class="hero-tagline">PLACEHOLDER_HERO_TAGLINE</p>
    <div class="hero-form">
      <div class="hero-form-title"><i class="fa-solid fa-clipboard-check"></i> Get a Free Storm Assessment</div>
      <div class="form-row">
        <input type="text" placeholder="First Name">
        <input type="text" placeholder="Last Name">
      </div>
      <div class="form-row">
        <input type="tel" placeholder="Phone Number">
        <input type="email" placeholder="Email Address">
      </div>
      <div class="form-row full">
        <select>
          <option value="" disabled selected>Service Needed</option>
          <option>Emergency Tarping</option>
          <option>Insurance Claim Help</option>
          <option>Full Roof Replacement</option>
          <option>Damage Assessment</option>
          <option>Repairs &amp; Patches</option>
        </select>
      </div>
      <button type="submit" class="form-submit"><i class="fa-solid fa-bolt"></i> Get Free Assessment — It's Urgent</button>
    </div>
  </div>
  <div class="hero-right">
    <div class="hero-photo-bg">
      <i class="fa-solid fa-house-chimney-crack"></i>
    </div>
    <div class="hero-photo-overlay"></div>
    <div class="hero-stat-grid">
      <div class="stat-box">
        <span class="stat-num-big">24/7</span>
        <div class="stat-label-sm">Emergency Response</div>
      </div>
      <div class="stat-box">
        <span class="stat-num-big">100%</span>
        <div class="stat-label-sm">Insurance Coverage</div>
      </div>
      <div class="stat-box">
        <span class="stat-num-big">$0</span>
        <div class="stat-label-sm">Out of Pocket*</div>
      </div>
      <div class="stat-box">
        <span class="stat-num-big">48h</span>
        <div class="stat-label-sm">Job Start Time</div>
      </div>
    </div>
  </div>
</section>

<div class="trust-bar">
  <div class="trust-item"><i class="fa-solid fa-bolt"></i> 24/7 Emergency Response</div>
  <div class="trust-item"><i class="fa-solid fa-file-invoice-dollar"></i> Insurance Specialists</div>
  <div class="trust-item"><i class="fa-solid fa-certificate"></i> GAF &amp; Owens Corning Certified</div>
  <div class="trust-item"><i class="fa-solid fa-shield-halved"></i> Fully Insured</div>
  <div class="trust-item"><i class="fa-solid fa-magnifying-glass"></i> Free Damage Inspections</div>
</div>

<section class="services" id="services">
  <div class="services-header">
    <h2>Storm Damage <em>Services</em></h2>
    <p>From emergency tarping to full replacement — we handle everything, start to finish.</p>
  </div>
  <div class="srv-grid">
    PLACEHOLDER_SERVICE_CARDS_T7
  </div>
</section>

<div class="photo-wall">
  <div class="pw-cell">
    <div class="pw-icon"><i class="fa-solid fa-house-chimney"></i></div>
  </div>
  <div class="pw-cell">
    <div class="pw-icon"><i class="fa-solid fa-cloud-bolt"></i></div>
  </div>
  <div class="pw-cell">
    <div class="pw-icon"><i class="fa-solid fa-hard-hat"></i></div>
  </div>
</div>

<div class="stats-strip">
  <div class="stat-item anim d1">
    <span class="stat-num">24/7</span>
    <div class="stat-label">Emergency Response</div>
  </div>
  <div class="stat-item anim d2">
    <span class="stat-num">$0</span>
    <div class="stat-label">Out-of-Pocket Cost*</div>
  </div>
  <div class="stat-item anim d3">
    <span class="stat-num">100%</span>
    <div class="stat-label">Insurance Coverage</div>
  </div>
  <div class="stat-item anim d4">
    <span class="stat-num">48h</span>
    <div class="stat-label">Job Start Time</div>
  </div>
</div>

<section class="about" id="about">
  <div class="about-inner">
    <div class="about-content anim left">
      <div class="about-label">Who We Are</div>
      <h2>Northeast Ohio's <em>Storm</em> Specialists</h2>
      <p>PLACEHOLDER_ABOUT_PARA</p>
      <ul class="promise-list">
        <li><i class="fa-solid fa-check"></i> Free on-site storm damage inspection</li>
        <li><i class="fa-solid fa-check"></i> We meet directly with your insurance adjuster</li>
        <li><i class="fa-solid fa-check"></i> Certified installers — GAF, Owens Corning</li>
        <li><i class="fa-solid fa-check"></i> Lifetime workmanship warranty</li>
      </ul>
      <a href="#contact" class="btn-yellow">Schedule Free Inspection</a>
    </div>
    <div class="about-visual anim right">
      <div class="about-photo-main">
        <i class="fa-solid fa-house-chimney-crack"></i>
      </div>
      <div class="about-tagline-box">
        "We fight the insurance company so you don't have to."
      </div>
    </div>
  </div>
</section>

<section class="contact" id="contact">
  <div class="contact-inner">
    <div class="contact-hdr anim">
      <div class="eyebrow"><i class="fa-solid fa-bolt"></i> Storm Hit? Don't Wait.</div>
      <h2>Get Your Free Assessment Now</h2>
    </div>
    <form class="contact-form anim">
      <input type="text" placeholder="First Name">
      <input type="text" placeholder="Last Name">
      <input type="tel" placeholder="Phone Number">
      <input type="email" placeholder="Email Address">
      <input type="text" class="full" placeholder="Property Address">
      <select class="full">
        <option value="" disabled selected>Service Needed</option>
        <option>Emergency Tarping</option>
        <option>Insurance Claim Assistance</option>
        <option>Full Roof Replacement</option>
        <option>Repairs &amp; Patches</option>
        <option>Flat / Low-Slope Roofing</option>
        <option>Free Damage Assessment</option>
      </select>
      <textarea class="full" placeholder="Describe the damage or situation..." rows="4"></textarea>
      <button type="submit" class="contact-submit"><i class="fa-solid fa-bolt"></i> Send Request — Our Team Responds Fast</button>
    </form>
    <div class="contact-info">
      <div class="contact-info-item">
        <i class="fa-solid fa-phone"></i>
        <a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a>
      </div>
      <div class="contact-info-item">
        <i class="fa-solid fa-envelope"></i>
        <a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a>
      </div>
      <div class="contact-info-item">
        <i class="fa-solid fa-location-dot"></i>
        <span>PLACEHOLDER_ADDRESS</span>
      </div>
    </div>
  </div>
</section>

<footer>
  <div class="footer-grid">
    <div class="footer-brand">
      <div class="footer-logo">
        PLACEHOLDER_FOOTER_LOGO_T7
      </div>
      <p>Fast response, honest work, and a team that fights for what you're owed — Northeast Ohio's storm damage specialists.</p>
    </div>
    <div class="footer-col">
      <h4>Services</h4>
      <ul>
        <li><a href="#services">Emergency Tarping</a></li>
        <li><a href="#services">Insurance Claims</a></li>
        <li><a href="#services">Full Replacement</a></li>
        <li><a href="#services">Repairs &amp; Patches</a></li>
        <li><a href="#services">Free Inspection</a></li>
      </ul>
    </div>
    <div class="footer-col">
      <h4>Company</h4>
      <ul>
        <li><a href="#about">About Us</a></li>
        <li><a href="#about">Our Promise</a></li>
        <li><a href="#contact">Free Estimate</a></li>
        <li><a href="#contact">Contact Us</a></li>
      </ul>
    </div>
    <div class="footer-col">
      <h4>Contact</h4>
      <ul>
        <li><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></li>
        <li><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></li>
        <li><a href="#contact">PLACEHOLDER_ADDRESS</a></li>
      </ul>
    </div>
  </div>
  <div class="footer-bottom">
    <p>&copy; 2025 PLACEHOLDER_COMPANY. All rights reserved.</p>
    <p>Licensed Roofing Contractor — Ohio &nbsp;|&nbsp; *With approved insurance claim</p>
  </div>
</footer>

<div class="footer-tracking">PLACEHOLDER_TRACKING</div>

<script>
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('on'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.anim').forEach(el => observer.observe(el));
</script>
</body>
</html>`;

// ─── Generator ────────────────────────────────────────────────────────────────
export function generateRoofingMockup(templateId, data) {
  const {
    company = 'Your Company',
    phone = '',
    email = '',
    address = '',
    logoUrl = '',
    services = null,
    copy = null,
  } = data;

  const phoneDigits = phone.replace(/\D/g, '');

  function navLogo(imgClass) {
    if (logoUrl) return `<img src="${logoUrl}" alt="${company}" class="${imgClass}"> ${company}`;
    return company;
  }
  function footerLogo(imgClass) {
    if (logoUrl) return `<img src="${logoUrl}" alt="${company}" class="${imgClass}"> ${company}`;
    return company;
  }

  if (templateId === 6) {
    const tmplCopy = copy || ROOFING_DEFAULT_COPY.T6;
    const tmplServices = services || ROOFING_DEFAULT_SERVICES[6];
    const serviceCards = buildRoofingServiceCardsT6(tmplServices);

    const colors = `
      :root {
        --bg: #f9f7f4;
        --cream: #f2ede6;
        --border: #e5ddd4;
        --slate: #1c2331;
        --slate-mid: #263042;
        --terra: #c9603a;
        --terra-dk: #a84e2e;
        --white: #ffffff;
        --text: #1c2331;
        --muted: #6b6158;
      }
    `;

    return T6
      .replace('PLACEHOLDER_BRAND_COLORS_T6', colors)
      .replace(/PLACEHOLDER_COMPANY/g, company)
      .replace(/PLACEHOLDER_PHONE_DIGITS/g, phoneDigits)
      .replace(/PLACEHOLDER_PHONE/g, phone)
      .replace(/PLACEHOLDER_EMAIL/g, email)
      .replace(/PLACEHOLDER_ADDRESS/g, address)
      .replace('PLACEHOLDER_NAV_LOGO_T6', navLogo('nav-logo-img'))
      .replace('PLACEHOLDER_FOOTER_LOGO_T6', footerLogo('footer-logo-img'))
      .replace('PLACEHOLDER_HERO_EYEBROW', tmplCopy.eyebrow)
      .replace('PLACEHOLDER_HERO_H1', tmplCopy.headline)
      .replace('PLACEHOLDER_HERO_TAGLINE', tmplCopy.tagline)
      .replace('PLACEHOLDER_ABOUT_PARA', tmplCopy.about)
      .replace('PLACEHOLDER_SERVICE_CARDS_T6', serviceCards)
      .replace('PLACEHOLDER_TRACKING', '')
      .replace(/PLACEHOLDER_IMG/g, 'https://semdeckdigital.github.io/semdeck-claude-mockups/images');
  }

  if (templateId === 7) {
    const tmplCopy = copy || ROOFING_DEFAULT_COPY.T7;
    const tmplServices = services || ROOFING_DEFAULT_SERVICES[7];
    const serviceCards = buildRoofingServiceCardsT7(tmplServices);

    const colors = `
      :root {
        --bg: #0c0f14;
        --surface: #14181f;
        --yellow: #eab308;
        --text: #f1f5f9;
      }
    `;

    const headlineParts = tmplCopy.headline.split('. ');
    const line1 = headlineParts[0] + (headlineParts.length > 1 ? '.' : '');
    const line2 = headlineParts.length > 1 ? headlineParts.slice(1).join('. ') : '';

    return T7
      .replace('PLACEHOLDER_BRAND_COLORS_T7', colors)
      .replace(/PLACEHOLDER_COMPANY/g, company)
      .replace(/PLACEHOLDER_PHONE_DIGITS/g, phoneDigits)
      .replace(/PLACEHOLDER_PHONE/g, phone)
      .replace(/PLACEHOLDER_EMAIL/g, email)
      .replace(/PLACEHOLDER_ADDRESS/g, address)
      .replace('PLACEHOLDER_NAV_LOGO_T7', navLogo('nav-logo-img'))
      .replace('PLACEHOLDER_FOOTER_LOGO_T7', footerLogo('footer-logo-img'))
      .replace('PLACEHOLDER_HERO_EYEBROW', tmplCopy.eyebrow)
      .replace('PLACEHOLDER_HERO_H1_LINE1', line1)
      .replace('PLACEHOLDER_HERO_H1_LINE2', line2)
      .replace('PLACEHOLDER_HERO_TAGLINE', tmplCopy.tagline)
      .replace('PLACEHOLDER_ABOUT_PARA', tmplCopy.about)
      .replace('PLACEHOLDER_SERVICE_CARDS_T7', serviceCards)
      .replace('PLACEHOLDER_TRACKING', '');
  }

  return '<p>Unknown roofing template ID</p>';
}
